import { openApp } from "@bilibili/openapp-lib";
import { getCookie } from "@bilibili/growup-utils";
import { PAGE_URLS } from "./config";
import { parseParamToObj } from "@/utils/detect";
const open_app_addition = JSON.stringify({
  spmid: "888.76655.selfDef.help",
  h5_buvid: getCookie("buvid3"),
  sessionId: `${getCookie("buvid3")}_${new Date().getTime()}`
});
const searchParams: any = parseParamToObj(location) || {};
let androidLink =
  "https://dl.hdslb.com/mobile/latest/android64/iBiliPlayer-html5_campaign_dahoudmbx_20221228_share_act04.apk";
if (searchParams["bsource"] && searchParams["bsource"] === "campaign_dahoudmbx_20221228_weibo_act01") {
  androidLink =
    "https://dl.hdslb.com/mobile/latest/android64/iBiliPlayer-html5_campaign_dahoudmbx_20221228_weibo_act01.apk";
} else if (searchParams["bsource"] && searchParams["bsource"] === "campaign_dahoudmbx_20221228_wechat_act02") {
  androidLink =
    "https://dl.hdslb.com/mobile/latest/android64/iBiliPlayer-html5_campaign_dahoudmbx_20221228_wechat_act02.apk";
} else if (searchParams["bsource"] && searchParams["bsource"] === "campaign_dahoudmbx_20221228_community_act03") {
  androidLink =
    "https://dl.hdslb.com/mobile/latest/android64/iBiliPlayer-html5_campaign_dahoudmbx_20221228_community_act03.apk";
}
export function openAPPUrl(url: string) {
  const schema = `bilibili://browser?url=${encodeURIComponent(url)}`;
  openApp({
    schema,
    universalLink: url,
    androidLink,
    h5awaken: {
      open_app_groupid: "",
      session_id: `${getCookie("buvid3")}_${new Date().getTime()}`,
      open_app_uuid: getCookie("_uuid"),
      open_app_from_type: "h5",
      open_app_url: url,
      open_app_addition
    }
  });
}

// Home页，站外h5唤端到站内
export function openAPPUrlForHome(search: string) {
  const url = PAGE_URLS.HOME + search;
  const schema = `bilibili://browser?url=${encodeURIComponent(url)}`;
  const addition = JSON.stringify({
    spmid: "888.76895.selfDef.home",
    h5_buvid: getCookie("buvid3"),
    sessionId: `${getCookie("buvid3")}_${new Date().getTime()}`
  });
  openApp({
    schema,
    universalLink: url,
    androidLink,
    h5awaken: {
      open_app_groupid: "",
      session_id: `${getCookie("buvid3")}_${new Date().getTime()}`,
      open_app_uuid: getCookie("_uuid"),
      open_app_from_type: "h5",
      open_app_url: url,
      open_app_addition: addition
    }
  });
}

export function openAPPHome() {
  const schema = "bilibili://home";
  const url = "https://m.bilibili.com/index.html";

  openApp({
    schema,
    universalLink: url,
    androidLink,
    h5awaken: {
      open_app_groupid: "",
      session_id: `${getCookie("buvid3")}_${new Date().getTime()}`,
      open_app_uuid: getCookie("_uuid"),
      open_app_from_type: "h5",
      open_app_url: url,
      open_app_addition
    }
  });
}

export function openAPPNoDownLoad(url: string) {
  // const {isiOS, isAndroid, isQQ} = detector;
  const schema = `bilibili://browser?url=${encodeURIComponent(url)}`;
  setTimeout(() => {
    location.href = schema;
  }, 0);

  // if(isAndroid) {
  //  location.href = schema;
  // }
}
